module.exports = __webpack_public_path__ + "img/videoIcon.40ece7d5.png";